import { Link, useLocation, useNavigate } from "react-router-dom";
import { MessageSquareText, Settings2, Lock, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BrandMark } from "@/components/BrandMark";
import { cn } from "@/lib/utils";
import { LS } from "@/lib/apiClient";

export function Brand({ subtitle }) {
  return (
    <Link to="/" className="flex items-center gap-3 group" data-testid="brand-home-link">
      <BrandMark className="h-9 w-9 transition-transform duration-200 group-hover:scale-105" />
      <div className="leading-tight">
        <div className="font-display font-semibold tracking-tight text-[15px]">Persistent A.I.</div>
        <div className="text-[11px] text-muted-foreground -mt-0.5">{subtitle || "Memory Engine"}</div>
      </div>
    </Link>
  );
}

const NAV = [
  { to: "/console", label: "Chat Console", icon: MessageSquareText, testid: "nav-console" },
  { to: "/admin", label: "Admin", icon: Settings2, testid: "nav-admin" },
  { to: "/security", label: "Security", icon: Lock, testid: "nav-security" },
];

export function AppHeader({ right, showNav = true }) {
  const loc = useLocation();
  const navigate = useNavigate();
  const signOut = () => {
    localStorage.removeItem(LS.tenantKey);
    localStorage.removeItem(LS.tenantName);
    localStorage.removeItem(LS.adminKey);
    navigate("/");
  };
  return (
    <header className="sticky top-0 z-30 border-b border-border glass">
      <div className="mx-auto max-w-[1500px] px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <div className="flex items-center gap-6">
          <Brand />
          {showNav && (
            <nav className="hidden md:flex items-center gap-1">
              {NAV.map((n) => {
                const active = loc.pathname === n.to;
                const Icon = n.icon;
                return (
                  <Link key={n.to} to={n.to} data-testid={n.testid}
                    className={cn(
                      "flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors",
                      active ? "bg-secondary text-foreground" : "text-muted-foreground hover:text-foreground hover:bg-secondary/60"
                    )}>
                    <Icon className="h-4 w-4" />
                    {n.label}
                  </Link>
                );
              })}
            </nav>
          )}
        </div>
        <div className="flex items-center gap-3">
          {right}
          <Button variant="ghost" size="sm" onClick={signOut} data-testid="sign-out-button" className="text-muted-foreground">
            <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Exit</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
